
import "./CreditsPanel.css";
import moneyExchangeIcon from "../../../../Assets/Images/transaction-data.png";
import sampleIcon from "../../../../Assets/Images/info.png";
import { useNavigate } from "react-router-dom";

const CreditsPanel = ({ credits, setShowImageModal }) => {
    const navigate = useNavigate();
    const creditToLocalString = credits
        ? parseInt(Math.floor(credits)).toLocaleString()
        : "0";
    return (
        <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2 credit-responsive">
            <div>
                {/* <div>
                    <button className="credits-button">
                        CREDITS : {creditToLocalString}
                    </button>
                    <button
                        className="buy-credits-button"
                        onClick={() => navigate("/purchase")}
                    >
                        BUY CREDITS
                    </button>
                    <button
                        onClick={() => navigate("/usage")}
                        className="money-exchange-button"
                    >
                        <img src={moneyExchangeIcon} alt="usage" />
                    </button>
                </div> */}

                <p className="all-page-title all-page-gradient-text text-center my-4">IMAGE AI</p>

                <div className="credits-actions">

                    <button className="credits-button">
                        CREDITS : {creditToLocalString}
                    </button>

                    <button
                        className="buy-credits-button"
                        onClick={() => navigate("/purchase")}
                    >
                        BUY CREDITS
                    </button>

                    <button
                        onClick={() => navigate("/usage")}
                        className="money-exchange-button"
                    >
                        <img src={moneyExchangeIcon} alt="usage" />
                    </button>

                    <button
                        type="button"
                        className="money-exchange-button"
                        onClick={() => {
                            setShowImageModal(true);
                        }}

                    >
                        <img src={sampleIcon} alt="See sample video" />
                    </button>

                </div>
                <p
                    style={{ fontSize: "8px", marginBottom: 0 }}
                    className="text-white mt-2 creditText text-center"
                >
                    10 Credits Per Image (USD 0.12 based on Credits Package 3)
                </p>
            </div>
        </div>
    );
};

export default CreditsPanel;